module.exports = __webpack_public_path__ + "img/avatar.b4e60b7e.svg";